export default __webpack_public_path__ + "static/team-Brendons-3f4ea212d810b1bc0dc38690b7921044.png";